/**
 * V282-1: 휴가 단위 기본값 상수
 *
 * allowedUnits가 누락(undefined) 또는 빈 배열([])인 경우의 fallback 정책.
 *
 * 근거:
 * - BE createLeaveType 저장 기본값: ['fullDay']
 * - INITIAL_LEAVE_TYPES 시드 데이터: 8/11 타입이 ['fullDay']
 * - HR 휴가설정 수정 모달 초기값: ['fullDay']
 */
import { LeaveUnit } from '../types/leaveType';

export const DEFAULT_ALLOWED_UNITS: LeaveUnit[] = ['fullDay'];
